import {Inject, Injectable} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import {CITY, Source} from '../common/const';
import 'rxjs/add/observable/combineLatest';
import { POI_TYPES } from './layers/constants'
import { CartoService } from 'app/services/carto.service';

@Injectable()
export class HistoricContextService {

  public mobilePopup = new Subject<any>();
  public listenerLayerLoading = new Subject();
  private loadingList = [];
  private mode = new BehaviorSubject<any>({mode: 'live'});
  private sources = new BehaviorSubject<any>(
      (() => {
        const result = [];
        for (const s of Object.keys(Source)) {
          if (isNaN(Number(Source[s]))) {
            result.push(parseInt(s, 10));
          }
        }
        return result;
      })()
  );
  private categories = new BehaviorSubject<any>(this._initCategories());
  private bbox = new Subject<Array<any>>();
  private elementsForPopup = [];
  private elementsForPopupSubject = new Subject<Array<any>>();
  private filters = {
    fromDate: null,
    toDate: null,
    hour: false,
    fromHour: null,
    toHour: null,
    variable: {id: 1, name: 'Nivel de servicio', type: 'variable'},
    bbox: null,
    bypass: false,
    custom: false,
    customBBOX: [],
    ntram: null,
    type: POI_TYPES
  };
  filters$ = this.filters;
  mode$ = this.mode.asObservable();
  sources$ = this.sources.asObservable();
  categories$ = this.categories.asObservable();
  bbox$ = this.bbox.asObservable();
  elementsForPopup$ = this.elementsForPopupSubject.asObservable();
  cityVariables = new Subject<any>();
  levelDetail$: Subject<any> = new Subject<any>();


  historicLayersContext$ = Observable.combineLatest(
      this.mode,
      this.sources,
      this.categories
  );

  constructor(@Inject(CITY) private city, private cartoService: CartoService) {
  }

  getMode() {
    return this.mode.value;
  }

  setMode(mode: any) {
    this.mode.next(mode);
  }

  getSources() {
    return this.sources.value;
  }

  setSources(sources: Array<number>) {
    this.sources.next(sources);
  }

  getCategories() {
    return this.categories.value;
  }

  setCategories(categories: any) {
    this.categories.next(categories);
  }

  _initCategories() {
    return this.city;
  }

  setBbox(categories: Array<string>) {
    this.categories.next(categories);
  }

  getBbox() {
    return this.bbox;
  }

  setFilters(filters: any) {
    this.filters = filters
  }

  getFilters () {
    return this.filters;
  }

  loadPopup(popup) {
    this.elementsForPopup.push(popup);
    this.elementsForPopupSubject.next(this.elementsForPopup);
  }

  closePopup() {
    this.elementsForPopup = [];
    this.elementsForPopupSubject.next(this.elementsForPopup);
  }

  loadMobilePopup(html) {
    this.mobilePopup.next(html);
  }

  addToLoading(layer) {
    this.loadingList.push(layer);
    this.listenerLayerLoading.next(this.loadingList);
  }

  removeFromLoading() {
    this.loadingList.pop();
    this.listenerLayerLoading.next(this.loadingList);
  }

  getDetailLevel(ntram, start, end, type): any {
    const types = {
      1: `
        SELECT
        start_ts,
        end_ts,
        level
        FROM
        amb_waze_data_jams_agg_levels_times
        WHERE
        start_ts >= '${start}'
        AND start_ts < '${end}'
        AND ntram = ${ntram};
      `,
      2: `
        WITH differences AS (
          SELECT
            start_ts,
            EXTRACT(EPOCH FROM '${end}' - start_ts) AS diff_filter,
            EXTRACT(EPOCH FROM end_ts - start_ts) AS diff_duration
          FROM
            amb_waze_data_jams_agg_levels_times
          WHERE
            start_ts >= '${start}'
            AND start_ts < '${end}'
            AND ntram = ${ntram}
        ), durations AS (
          SELECT
            start_ts,
            CASE
              WHEN diff_filter >= diff_duration THEN
                diff_duration
              ELSE
                diff_filter
            END as duration_seconds
          FROM
            differences
        ), durations_by_day AS (
          SELECT
            DATE_TRUNC('day', start_ts) AS day,
            SUM(duration_seconds) AS duration_seconds
          FROM
            durations
          GROUP BY
            DATE_TRUNC('day', start_ts)
        )

        SELECT
          day AS start_ts,
          CASE
            WHEN day + interval '1 day' >= '${end}' THEN
              '${end}'
            ELSE
              day + interval '1 day'
          END AS end_ts,
          CASE
            WHEN duration_seconds < 600 THEN
              1
            WHEN duration_seconds >= 600
              AND duration_seconds < 1200 THEN
              2
            WHEN duration_seconds >= 1200
              AND duration_seconds < 1800 THEN
              3
            WHEN duration_seconds >= 1800
              AND duration_seconds < 3600 THEN
              4
            ELSE
              5
          END AS level
        FROM
          durations_by_day;
      `,
      3: `
          WITH road_sections_with_types AS (
            SELECT
              ntram,
              MODE() WITHIN GROUP (ORDER BY road_type ASC) AS road_type
            FROM
              amb_waze_data_jams_agg_hour
            WHERE
              georss_date >= '${start}'
              AND georss_date < '${end}'
              AND ntram = ${ntram}
            GROUP BY
              ntram
          ), road_sections_with_carrils AS (
            SELECT
              j.ntram,
              j.road_type,
              s.carrils
            FROM
              amb_streets s
              JOIN road_sections_with_types j ON s.ntram = j.ntram
          ), road_sections_with_intensities AS (
            SELECT
              jlt.start_ts,
              jlt.end_ts,
              CASE WHEN rsc.road_type IN (3, 6, 7, 17) THEN
                CASE WHEN jlt.level = 1 THEN
                  jlt.avg_speed * 50 * (COALESCE(carrils, 2) / 2)
                WHEN jlt.level = 2 THEN
                  jlt.avg_speed * 58 * (COALESCE(carrils, 2) / 2)
                WHEN jlt.level = 3 THEN
                  jlt.avg_speed * 72 * (COALESCE(carrils, 2) / 2)
                WHEN jlt.level = 4 THEN
                  jlt.avg_speed * 80 * (COALESCE(carrils, 2) / 2)
                WHEN jlt.level = 5 THEN
                  jlt.avg_speed * 94 * (COALESCE(carrils, 2) / 2)
                ELSE
                  0
                END
              ELSE
                CASE WHEN jlt.level = 1 THEN
                  jlt.avg_speed * 25 * COALESCE(carrils, 1)
                WHEN jlt.level = 2 THEN
                  jlt.avg_speed * 27 * COALESCE(carrils, 1)
                WHEN jlt.level = 3 THEN
                  jlt.avg_speed * 28 * COALESCE(carrils, 1)
                WHEN jlt.level = 4 THEN
                  jlt.avg_speed * 29 * COALESCE(carrils, 1)
                WHEN jlt.level = 5 THEN
                  jlt.avg_speed * 31 * COALESCE(carrils, 1)
                ELSE
                  0
                END
              END AS intensity
            FROM
              road_sections_with_carrils rsc
              JOIN amb_waze_data_jams_agg_levels_times jlt ON
                jlt.start_ts >= '${start}'
                AND jlt.start_ts < '${end}'
                AND rsc.ntram = jlt.ntram
          )

          SELECT
            start_ts,
            end_ts,
            CASE WHEN intensity >= 0
              AND intensity < 700 THEN
              1
            WHEN intensity >= 700
              AND intensity < 940 THEN
              2
            WHEN intensity >= 940
              AND intensity < 1250 THEN
              3
            WHEN intensity >= 1250
              AND intensity < 1550 THEN
              4
            ELSE
              5
            END AS level
          FROM
            road_sections_with_intensities
      `,
    }
    return this.cartoService.queryData(types[type]);
  }

}



// WEBPACK FOOTER //
// ./src/app/historic/historic-context.service.ts